import { render } from "./RotasGerencia.vue?vue&type=template&id=edec9e7e"
import script from "./RotasGerencia.vue?vue&type=script&lang=js"
export * from "./RotasGerencia.vue?vue&type=script&lang=js"

import "./RotasGerencia.vue?vue&type=style&index=0&id=edec9e7e&lang=css"

import exportComponent from "F:\\Projetos 2024\\e-logDash\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__